import React from "react";
import "tachyons/css/tachyons.css";

export default class Table extends React.Component {
  handleChange(event) {
    let geo = this.props.geojson;
    geo.features[event.target.name] = event.target.value
    this.props.setGeojson(geo)
  }
  render() {
    const { geojson } = this.props;
    if (geojson !== undefined) {
      let features = geojson.features;
      const allProperties = [
        ...new Set(
          features.reduce((memo, f) => {
            return memo.concat(Object.keys(f.properties || {}));
          }, [])
        )
      ];
      features.sort((a, b) => a.properties.title.localeCompare(b.properties.title));
      return (
        <div>
          <table className="stTable">
            <thead>
              <tr>
                {allProperties.map(prop => {
                  return <th className="" style={{paddingRight:"10px"}}>{prop}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {features.map(feature => {
                return (
                  <tr className="rw">
                    {allProperties.map(prop => {
                      return (
                        <td className="">
                          <input
                            className="avTable"
                            type="text"
                            defaultValue={feature.properties[prop]}
                            name={prop}
                            onChange={event => this.handleChange(event)}
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
    return <div />
  }
}
